import { FETCH_PURCHASE_STATUS } from './actionTypes'


export const fetchPurchaseStatus = (purchaseStatus) => ({
    type: FETCH_PURCHASE_STATUS,
    purchaseStatus
})

export default fetchPurchaseStatus;



// WEBPACK FOOTER //
// ./src/actions/purchaseStatusActions.js